/**
 * MEU ERP API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface RecruitRoundInterviewer { 
    id?: string;
    interview_round_id?: string;
    interviewer_id?: string;
    is_main_interviewer?: boolean;
    created_at?: Date;
    created_by?: string;
    modified?: Date;
    modified_by?: string;
}